{
  "organization": {
    "seatOverrun": {
      "title": "Organization locked",
      "description": "Your organization has more users than seats. An organization manager or system administrator must resolve this before the app can be used.",
      "seatPool": "Seat pool",
      "resolverDescription": "Suspend or delete users until every seat pool is within its limit.",
      "stuckDescription": "No seat in the over-full pool can be freed from here. Contact support to have the seat limit raised.",
      "overBy": "{{over}} over the limit",
      "loadError": "The seat data could not be loaded."
    },
    "tabs": {
      "departments": "Departments",
      "functions": "Functions",
      "teams": "Teams",
      "members": "People",
      "systems": "Systems",
      "externalContacts": "External Contacts",
      "artifacts": "Documents"
    },
    "organigram": {
      "title": "Organigram",
      "description": "Interactive organizational chart showing your department hierarchy",
      "empty": "No departments found. Create departments to build your organigram.",
      "fitView": "Fit to view",
      "memberCount_one": "{{count}} person",
      "memberCount_other": "{{count}} people",
      "manager": "Manager",
      "notAssigned": "Not assigned",
      "level": "Level"
    },
    "systems": {
      "title": "Systems",
      "description": "Manage all systems in your organization",
      "empty": "No systems found",
      "search": "Search systems...",
      "softwareSystem": "Software System",
      "category": "Category",
      "url": "Link to System",
      "create": "Create System",
      "editSystem": "Edit System",
      "createSystemDescription": "Add a new software system to your organization",
      "editSystemDescription": "Update the details of this software system",
      "namePlaceholder": "Enter system name",
      "descriptionPlaceholder": "Enter system description",
      "categoryPlaceholder": "Enter category",
      "urlPlaceholder": "https://example.com",
      "systemOwner": "System Owner",
      "systemOwnerPlaceholder": "Select system owner...",
      "basicInformation": "Basic Information",
      "ownership": "Ownership",
      "systemDetails": "System Details",
      "licenceSeatsLabel": "Licence Seats",
      "licenceSeatsPlaceholder": "e.g. 50",
      "notFound": "System not found",
      "noDescription": "No description available",
      "saveFailed": "Failed to save system",
      "logoUploadFailed": "The system was saved, but the logo upload failed. You can add the logo later by editing the system.",
      "stats": {
        "totalUsers": "Total Users",
        "totalUsersDescription": "Users involved with this system",
        "totalOrgFunctions": "Total Functions",
        "totalOrgFunctionsDescription": "Functions involved with this system",
        "totalRoles": "Total positions",
        "totalRolesDescription": "Different positions of the users",
        "totalProcesses": "Total Processes",
        "totalProcessesDescription": "Processes using this system",
        "capacityBinding": "Capacity Binding",
        "capacityBindingNoData": "No capacity data available",
        "perMonth": "per month",
        "perYear": "per year",
        "clickToToggle": "click to toggle",
        "costCalculation": "Cost Calculation",
        "costPerMonth": "Cost per month",
        "costPerYear": "Cost per year",
        "billingRateInfo": "Based on billing rate of {{rate}}/hour",
        "stepsWithData": "{{count}} of {{total}} steps have capacity data",
        "licenceSeats": "Licence Seats",
        "licenceSeatsUsed": "Seats used"
      },
      "capacityCell": {
        "monthSuffix": "/mo",
        "yearSuffix": "/yr"
      },
      "processesImpacted": {
        "title": "Processes Impacted",
        "processName": "Process Name",
        "stepsInvolved": "Steps Involved",
        "avgRating": "Avg Rating",
        "mediaBreaks": "Media Breaks",
        "capacity": "Capacity",
        "action": "Action",
        "viewSteps": "View Steps",
        "noProcesses": "No processes interact with this system yet",
        "stepExplorer": "Step Explorer"
      },
      "systemUsers": {
        "title": "System Users",
        "user": "User",
        "role": "Position",
        "involvedProcesses": "Involved Processes",
        "noUsers": "No users interact with this system yet",
        "searchPlaceholder": "Search users...",
        "filterByRole": "Filter by position",
        "allRoles": "All positions",
        "involvementType": {
          "owner": "Owner",
          "helper": "Helper",
          "whoElseDoesThis": "Also does this"
        }
      },
      "topRoles": {
        "title": "Top Positions",
        "noRoles": "No positions found for this system",
        "allRolesTitle": "All Positions"
      },
      "departments": {
        "title": "Departments",
        "noDepartments": "No departments found for this system",
        "membersSuffix": "people",
        "allDepartmentsTitle": "All Departments"
      },
      "topOrgFunctions": {
        "title": "Top Functions",
        "noOrgFunctions": "No functions found for this system",
        "allOrgFunctionsTitle": "All Functions"
      },
      "criticalDependencies": {
        "title": "Critical Dependency Warning",
        "description": "These process steps rely on a single person with no backup. If that person is unavailable, the step cannot be executed.",
        "processStep": "Process / Step",
        "assignedTo": "Assigned To",
        "role": "Position",
        "showAll": "Show all {{count}}",
        "showLess": "Show less"
      },
      "interactions": {
        "title": "System Interactions",
        "upstream": "UPSTREAM (INPUT)",
        "downstream": "DOWNSTREAM (OUTPUT)",
        "noUpstream": "No upstream systems",
        "noDownstream": "No downstream systems",
        "view3d": "3D",
        "viewList": "List",
        "viewFlow": "Flow",
        "fullscreen": "Fullscreen",
        "exitFullscreen": "Exit fullscreen",
        "resetView": "Reset view",
        "pause": "Pause rotation",
        "play": "Resume rotation",
        "linkInteractions": "{{count}} interaction",
        "linkInteractions_other": "{{count}} interactions"
      },
      "mediaBreakMap": {
        "title": "Media Break Map",
        "breaksBefore": "Breaks Before",
        "breaksAfter": "Breaks After",
        "mostFrequent": "Most Frequent Breaks",
        "foundInProcesses": "Found in {{count}} processes"
      },
      "deletePhrase": "this system"
    },
    "departments": {
      "title": "Departments",
      "description": "Overview of all departments in your organization",
      "empty": "No departments found",
      "search": "Search departments...",
      "members": "People",
      "noMembersFound": "No people found",
      "searchMembers": "Search people...",
      "teams": "Teams",
      "noTeamsFound": "No teams in this department",
      "searchTeams": "Search teams...",
      "headOfDepartment": "Head of Department",
      "abbreviation": "Abbreviation",
      "create": "Create Department",
      "editDepartment": "Edit Department",
      "createDepartmentDescription": "Add a new department to your organization",
      "editDepartmentDescription": "Update the details of this department",
      "namePlaceholder": "Enter department name",
      "descriptionPlaceholder": "Enter department description",
      "parentDepartment": "Parent Department",
      "selectParent": "Select parent department",
      "manager": "Manager",
      "selectManager": "Select manager",
      "relationships": "Assignment",
      "notFound": "Department not found",
      "detailDescription": "View and manage department details",
      "details": "Department Details",
      "bulkUpload": "Bulk Upload",
      "bulkUploadPage": {
        "title": "Bulk Upload Departments",
        "description": "Upload multiple departments from Excel with hierarchical relationships",
        "uploadFromExcel": "Upload from Excel",
        "downloadTemplate": "Download Template",
        "draftDepartments": "Draft Departments",
        "createAll": "Create All",
        "cancel": "Cancel",
        "fixErrorsWarning": "Please fix all errors before submitting",
        "successCreated": "Successfully created {{count}} departments",
        "validationError": "Validation failed. Please fix errors and try again",
        "circularDependency": "Circular dependency detected in department hierarchy",
        "parentInBatch": "Parent will be created in this batch",
        "parentInDatabase": "Parent exists in database",
        "parentNotFound": "Parent department not found",
        "creationOrder": "Creation Order",
        "rowNumber": "Row #",
        "noDrafts": "No draft departments. Upload from Excel or add manually.",
        "uploadSuccess": "Successfully parsed {{count}} departments",
        "uploadPartial": "Parsed {{valid}} valid and {{invalid}} invalid departments",
        "uploadAllInvalid": "All {{count}} departments have errors",
        "fileInvalidFormat": "Invalid file format. Please upload Excel file (.xlsx or .xls)",
        "uploadError": "Error uploading Excel file",
        "addManually": "Add Manually",
        "addManuallyDescription": "Add a single department to the batch",
        "editDraft": "Edit Draft Department",
        "editDraftDescription": "Modify department details",
        "confirmDeleteDraft": "Remove this department from the upload?",
        "parentComboPlaceholder": "Select existing or type batch abbreviation",
        "managerEmailPlaceholder": "manager@example.com",
        "validationErrors": "Validation Errors",
        "instruction1": "Required fields: Name and Abbreviation",
        "instruction2": "Parent Abbreviation can reference existing departments or departments in this upload",
        "instruction3": "Avoid circular dependencies (A → B → A)",
        "instruction4": "Manager Email must match an existing user in the system",
        "circularDependencyReview": "Please review parent-child relationships to ensure there are no circular dependencies.",
        "useBatchAbbreviation": "Use \"{{abbreviation}}\" as batch abbreviation",
        "existingDepartments": "Existing Departments (Database)",
        "batchDepartments": "Batch Departments (Current Upload)"
      },
      "deletePhrase": "this department"
    },
    "orgFunctions": {
      "details": "Function Details",
      "namePlaceholder": "Enter function name",
      "emailPlaceholder": "Enter email address",
      "descriptionPlaceholder": "Enter description",
      "selectDepartment": "Select department",
      "noDepartment": "No department",
      "selectLead": "Select function lead",
      "selectTeamLead": "Select team lead",
      "noLead": "No function lead",
      "noTeamLead": "No team lead",
      "email": "Shared mailbox",
      "lead": "Function Lead",
      "teamLead": "Team Lead",
      "department": "Department",
      "kind": {
        "label": "Type",
        "team": "Team",
        "role": "Function"
      },
      "members": {
        "title": "People",
        "empty": "No people found",
        "search": "Search people...",
        "leadBadge": "Function Lead",
        "label": "People (additional function)",
        "hint": "Selected people hold this function as an additional function alongside their position.",
        "hintMainRoleLocked": "People whose position is this function are pre-selected and locked.",
        "available": "Available people",
        "selected": "Selected people",
        "filterByDepartment": "Filter by department",
        "loadError": "The people holding this function couldn't be loaded. Close the dialog and try again to edit them.",
        "mainRoleLocked": "This function is assigned as a position and can't be removed here — change the person's position instead."
      },
      "memberCount": "People",
      "deletePhrase": {
        "team": "this team",
        "role": "this function"
      }
    },
    "functions": {
      "title": "Functions",
      "description": "Manage all functions in your organization",
      "empty": "No functions found",
      "search": "Search functions...",
      "create": "Create Function",
      "createDescription": "Add a new function to your organization",
      "edit": "Edit Function",
      "editDescription": "Update the details of this function",
      "detailDescription": "View function details",
      "notFound": "Function not found"
    },
    "teams": {
      "title": "Teams",
      "description": "Manage all teams in your organization",
      "empty": "No teams found",
      "search": "Search teams...",
      "create": "Create Team",
      "createDescription": "Add a new team to your organization",
      "edit": "Edit Team",
      "editDescription": "Update the details of this team",
      "detailDescription": "View team details",
      "notFound": "Team not found"
    },
    "myOrgFunctions": {
      "title": "My Functions",
      "description": "See which functions and teams you act in within your company.",
      "empty": "No function has been assigned to you yet."
    },
    "members": {
      "title": "People",
      "description": "Overview of all employees in your organization",
      "empty": "No people found",
      "search": "Search people...",
      "createMember": "Create Person",
      "inviteAllInactive": "Invite all inactive users",
      "inviteAllInactiveConfirm": "Send invitation emails to {{count}} inactive user(s)?",
      "inviteAllInactiveSuccess": "Sent {{count}} invitation(s)",
      "inviteAllInactiveSkipped": "{{count}} user(s) were skipped",
      "editMember": "Edit Person",
      "createMemberDescription": "Add a new person to your organization",
      "editMemberDescription": "Update the details of this person",
      "notFound": "Person not found",
      "detailDescription": "View and manage person details",
      "details": "Person Details",
      "firstName": "First Name",
      "lastName": "Last Name",
      "firstNamePlaceholder": "Enter first name",
      "lastNamePlaceholder": "Enter last name",
      "emailPlaceholder": "Enter email address",
      "emailChangeWarning": "This changes the email address this person uses to sign in.",
      "relationships": "Assignment",
      "selectDepartment": "Select department",
      "mainRole": "Position",
      "selectMainRole": "Select position",
      "secondaryRoles": "Additional functions",
      "selectSecondaryRoles": "Select additional functions",
      "location": "Location",
      "selectLocation": "Select location",
      "accessPermissions": "Access & Permissions",
      "selectUserTypes": "Select user types",
      "selectClassification": "Select classification",
      "externalOrganization": "External Organization",
      "externalOrgPlaceholder": "Enter external organization name",
      "sendInvitation": "Send invitation email",
      "sendInvitationHelper": "The person will be notified by email.",
      "statusActions": "Actions",
      "sendInvitationAction": "Send Invitation",
      "resendInvitationAction": "Resend Invitation",
      "userInactive": "This user has not been invited yet",
      "userPendingInvitation": "This user is awaiting account activation. You can resend the invitation if needed.",
      "userSuspended": "This user is currently suspended",
      "suspendUser": "Suspend User",
      "unsuspendUser": "Unsuspend User",
      "sendInvitationSuccess": "Invitation sent",
      "suspendSuccess": "User suspended",
      "unsuspendSuccess": "User unsuspended",
      "suspendUserPrompt": "You can suspend this user to temporarily revoke access",
      "resetSignInAction": "Reset Sign-In",
      "resetSignInDescription": "The current sign-in methods of {{name}} ({{email}}) — password, passkeys, authenticator apps — stop working, and this person is signed out of every workspace. They receive an email to set up their sign-in again and cannot sign in until they do.",
      "resetSignInConfirmInstruction": "Type <strong /> to confirm the reset.",
      "resetSignInConfirmLabel": "Name of the person",
      "resetSignInSuccess": "Sign-in reset. An email to set it up again was sent.",
      "homeOrgDeletedBadge": "Home organization deleted",
      "homeOrgDeletedTooltip": "This member's home organization was deleted — sign-in is (or will be) blocked. A platform administrator can assign a new home organization to restore access.",
      "deletePhrase": "this person"
    },
    "contacts": {
      "title": "External Contacts",
      "description": "Overview of all external contacts",
      "empty": "No external contacts found",
      "search": "Search external contacts...",
      "create": "Create Contact",
      "notFound": "Contact not found",
      "detailDescription": "View and manage contact details",
      "details": "Contact Details",
      "deletePhrase": "this contact"
    },
    "externalContacts": {
      "createContact": "Create Contact",
      "editContact": "Edit Contact",
      "createContactDescription": "Add a new external contact",
      "editContactDescription": "Update the details of this contact",
      "nameLabel": "Contact name",
      "typeSectionLabel": "Contact type",
      "typeLabel": "Contact type (select from list or create new)",
      "namePlaceholder": "Enter contact name (e.g. Acme Bank, private customer)",
      "typePlaceholder": "Select contact type",
      "descriptionPlaceholder": "Enter description",
      "types": {
        "customer": "Customer",
        "partner": "Partner",
        "vendor": "Vendor",
        "other": "Other"
      }
    },
    "artifacts": {
      "title": "Documents",
      "description": "Overview of all documents used in your organization's processes",
      "empty": "No documents found",
      "search": "Search documents...",
      "size": "Size",
      "createdBy": "Created By",
      "type": "File Format",
      "fileUrl": "Link to Document",
      "create": "Create Document",
      "editArtifact": "Edit Document",
      "createArtifactDescription": "Add a new document",
      "editArtifactDescription": "Update the details of this document",
      "namePlaceholder": "e.g. Customer classification checklist",
      "descriptionPlaceholder": "e.g. Checklist for customer classification.",
      "typePlaceholder": "e.g. PDF, Excel, Word",
      "fileUrlPlaceholder": "https://example.com/file.pdf",
      "notFound": "Document not found",
      "detailDescription": "View and manage document details",
      "details": "Document Details",
      "addNew": "Add new",
      "types": {
        "document": "Document",
        "image": "Image",
        "video": "Video",
        "other": "Other"
      },
      "deletePhrase": "this document"
    }
  },
  "organizations": {
    "Level": "Level",
    "Abbreviation": "Abbreviation",
    "Description": "Description",
    "ParentDepartment": "Parent Department"
  },
  "OrgSettingPage": {
    "Settings": "Settings",
    "editKeyDetails": "Configure your organization's settings",
    "OrganizationLogo": "Organization Logo",
    "Upload": "Upload",
    "Organizationname": "Organizationname",
    "Language": "Language",
    "RecordingTime": "Default recording time (hours)",
    "recordingTimeHint": "How long should it take before an assigned process-step recording counts as 'overdue'?",
    "reviewTimeFrame": "Standard Process review timeframe",
    "reviewTimeFrameHint": "After how many days do you want to record the same process again to see whether it has changed?",
    "RatingAndComment": "Rating and Comment",
    "FrequencyMeasurement": "Frequency Measurement",
    "DurationMeasurement": "Duration Measurement",
    "VariantCheck": "Variant Check",
    "SettingSaved": "Setting saved successfully.",
    "ExportData": "Export data",
    "ExportDataSuccess": "Data exported successfully!",
    "days": "Days",
    "hours": "Hours",
    "logoUploadHint": "SVG, PNG, JPG or GIF (max. 800x800px) or 3MB",
    "fieldRequired": "Field is required.",
    "noCommaAllowed": "Value must not contain a comma.",
    "mustBePositive": "Value must be greater than 0.",
    "internalBillingRate": "Internal billing rate",
    "internalBillingRateUnit": "€/h",
    "languageEnglish": "English",
    "languageGerman": "Deutsch",
    "languageHungarian": "Magyar",
    "languageFrench": "Français",
    "organizationProfileTitle": "Organization Profile",
    "organizationProfileDesc": "Manage your organization's logo and identity",
    "preferencesTitle": "Preferences",
    "preferencesDesc": "Set default values for your organization.",
    "surveySettingsTitle": "Survey Settings",
    "surveySettingsDesc": "Control which surveys are shown to people after recording and which values should be collected",
    "capacityPriority": "Capacity source",
    "capacityPrioritySurveyFirst": "Surveyed first",
    "capacityPrioritySurveyFirstDesc": "The surveyed value; if there is none, the manual value counts.",
    "capacityPriorityManualFirst": "Manual first",
    "capacityPriorityManualFirstDesc": "The manual value; if there is none, the surveyed value counts.",
    "capacityPrioritySurveyOnly": "Surveyed only",
    "capacityPrioritySurveyOnlyDesc": "Only surveyed values count. Manual values stay stored.",
    "capacityPriorityManualOnly": "Manual only",
    "capacityPriorityManualOnlyDesc": "Only manual values count. Surveyed values stay stored.",
    "privacyMode": "Process Visibility",
    "privacyNeedToKnow": "Need to Know",
    "privacyNeedToKnowDesc": "Users only see processes they are assigned to",
    "privacyFullTransparency": "Full Transparency",
    "privacyFullTransparencyDesc": "All users can see every process",
    "ai": {
      "title": "AI Features",
      "description": "Enable and configure AI-powered features for your organization",
      "bliksyEnableLabel": "Enable Bliksy",
      "bliksyEnableDescription": "Allow users to use the Bliksy AI assistant during recordings",
      "stepNameGenerationLabel": "Auto-generate Step Names",
      "stepNameGenerationDescription": "Automatically generate names and descriptions for recorded process steps using AI",
      "appsTitle": "AI features of the apps",
      "appsDescription": "Switch individual AI features of your organisation's apps on or off. An app hides a feature that is off."
    }
  },
  "department": {
    "tabs": {
      "members": "People",
      "teams": "Teams"
    },
    "selector": {
      "placeholder": "Select department..."
    },
    "members": {
      "title": "People in my department",
      "description": "Manage people in the {{department}} department",
      "descriptionDefault": "Manage people in your department",
      "empty": "No people found in your department",
      "search": "Search people...",
      "createMember": "Add Person"
    },
    "teams": {
      "title": "My Department Teams",
      "description": "Manage teams of the {{department}} department",
      "descriptionDefault": "Manage the teams of your department",
      "empty": "Your departments have no fixed teams",
      "search": "Search teams...",
      "createTeam": "Add Team",
      "noAccess": "You are not managing any department."
    }
  },
  "organizationSettings": {
    "userManagement": {
      "title": "User Management",
      "description": "Manage user access, types, and permissions for your organization."
    },
    "softwareList": {
      "title": "Software List",
      "description": "Manage and configure software systems used by your organization.",
      "create": "Create System",
      "empty": "No systems found"
    }
  }
}
